import { z } from "zod";

/**
 * Suppliers: who stock is bought from.
 *
 * Deliberately thin. `terms` is free text — "30 days", "cash on delivery" —
 * rather than a modelled payment schedule, because v1 has no accounts payable
 * and a structured field nobody computes with is a form somebody has to fill in
 * for nothing.
 */

export const createSupplierRequest = z.object({
  name: z.string().trim().min(2, "Enter the supplier's name").max(160),
  phone: z.string().trim().max(40).nullable().optional(),
  address: z.string().trim().max(240).nullable().optional(),
  terms: z.string().trim().max(120).nullable().optional(),
  notes: z.string().trim().max(500).nullable().optional(),
});

export const updateSupplierRequest = createSupplierRequest.partial().extend({
  /** Deactivating is how a supplier stops appearing. Nothing is ever deleted. */
  isActive: z.boolean().optional(),
});

export const supplierResponse = z.object({
  id: z.string().uuid(),
  name: z.string(),
  phone: z.string().nullable(),
  address: z.string().nullable(),
  terms: z.string().nullable(),
  notes: z.string().nullable(),
  isActive: z.boolean(),
});

export const supplierListResponse = z.object({
  suppliers: z.array(supplierResponse),
});

export type CreateSupplierRequest = z.infer<typeof createSupplierRequest>;
export type UpdateSupplierRequest = z.infer<typeof updateSupplierRequest>;
export type SupplierResponse = z.infer<typeof supplierResponse>;
